import generic_backend_request_post from 'functions/server/generic_backend_request_post';

async function cancel_run(run_id) {
    /**
     * Cancels a queued or running optimization solve.
     *
     * Queued runs are skipped by the worker; a run already solving is cancelled
     * best-effort (its result is discarded when the uninterruptible solve finishes).
     * Terminal runs (succeeded/failed/cancelled) are returned unchanged.
     *
     * @param {string} run_id - The ID of the run to cancel.
     * @returns {Object} { run_id, status, error, ... } — the run's current status.
     */
    if (!run_id) {
        throw new Error('Run ID is required for cancel_run');
    }

    const retJson = await generic_backend_request_post({ run_id }, '/cancel_run');
    return retJson;
}

export default cancel_run;
